import { createStyles, makeStyles } from '@material-ui/styles';
import CupsLeft from 'assets/background/pedagogicalChallenges/cups_left.webp';
import CupsRight from 'assets/background/pedagogicalChallenges/cups_right.webp';
import palette from 'theme/palette';

const style = () =>
  createStyles({
    root: {
      marginTop: '10px',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    topModule: {
      backgroundImage: `url(${CupsLeft}),url(${CupsRight}), ${palette.gradient.blue}`,
      backgroundPosition: 'left, right, left',
      backgroundRepeat: 'no-repeat,no-repeat,no-repeat',
      backgroundSize: '30%,30%,100%',
      borderRadius: palette.borderRadius.default,
      fontWeight: 600,
      padding: 10,
      color: palette.text.white,
      fontSize: '1.5rem',
      fontStyle: 'italic',
      display: 'flex',
      justifyContent: 'center'
    },
    lastDefiContainer: {
      marginTop: '20px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
